import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import jwt_decode from "jwt-decode";

const useAuth=()=>{
   const [cookies] = useCookies(['Token']);
   const user=cookies.Token
   // console.log(`OBA : ${user} `)
   let decodedToken = jwt_decode(user);
   console.log("Decoded Token", decodedToken);
   let currentDate = new Date();

   if(user === "undefined" || user === "") {
      return false
   } else {
      // now check if JWT token is still valid
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
         console.log("Token expired.");
         return false
      } else {
         console.log("Valid token");   
         return true
      }
   }  
}

const PrivateRoute = () => {   
   const auth=useAuth()
   // console.log(`Logged In ? ${auth}`)
   return auth ? <Outlet/>: <Navigate to="/login"/>
}

export default PrivateRoute